import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { translate } from '../Services/translation';
import { getHeaderInformationData } from '../Actions/GenericGridView.action';
class HeaderInformationData extends Component {

    constructor(props) {
        super(props);
        this.state = { ...props };
        this.clickHandler = this.clickHandler.bind(this);
        this.lastClickedNode = null;
        this.state.updating = false;
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.clickHandler);

        const { getHeaderInformationData } = this.props;
        if (getHeaderInformationData) {
            getHeaderInformationData();
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.clickHandler);
    }

    clickHandler(event) {
        this.lastClickedNode = event.target;
    }

    componentWillUpdate({ showData } = props) {

    }

    render() {
        const { headerInformation } = this.props;
        return (
            <Fragment>{headerInformation && headerInformation.length>0 &&
                <div className="header__main-info-container">
                    <div className="header__main-info-content" dangerouslySetInnerHTML={{ __html: headerInformation }}></div>
                </div>}
            </Fragment>
        );
    }
}

const mapStateToProps = ({ genericGridView }) => genericGridView;

const mapDispatchToProps = dispatch => {
    return {
        getHeaderInformationData: () => dispatch(getHeaderInformationData()),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(HeaderInformationData);